var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { staticClass: "hover:text-red", on: { click: _vm.masquerade } },
    [_c("EyeIcon")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }